import { $Elements, MobileBreakpoint } from './constants';
import { debounce } from 'throttle-debounce';

export function escapeHTML(strings) {

	let result = strings[0];

	for (let i = 1; i < arguments.length; i++) {
		result += String(arguments[i]).replace(/[&<>'"]/g, (c) => {
			return {'&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;'}[c];
		});
		result += strings[i];
	};

	return result;
}

export function replaceHoverByActive() {

	if(!!('ontouchstart' in window) || !!('msmaxtouchpoints' in window.navigator)) {
		for(let sheetI = document.styleSheets.length - 1; sheetI >= 0; sheetI--) {
			let sheet = document.styleSheets[sheetI];
			if(sheet.cssRules) {
				for(let ruleI = sheet.cssRules.length - 1; ruleI >= 0; ruleI--) {
					let rule = sheet.cssRules[ruleI];
					if(rule.selectorText) {
						rule.selectorText = rule.selectorText.replace(':hover', ':active');
					}
				}
			}
		}
	}
}

export const calculateMenuOffset = (target) => target.offset().top - ((window.innerWidth < MobileBreakpoint) ? 80 : 110);

export function updateOnResize(mobile, desktop) {

	$Elements.window.on('resize', debounce(200, function() {

		if(typeof mobile === 'function' && window.innerWidth < MobileBreakpoint) {
			mobile();
		}
		else if(typeof desktop === 'function' && window.innerWidth >= MobileBreakpoint) {
			desktop();
		}

	}));
}
